import { render, staticRenderFns } from "./ApprovalComplete.vue?vue&type=template&id=3b17d630&scoped=true"
import script from "./ApprovalComplete.vue?vue&type=script&lang=js"
export * from "./ApprovalComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b17d630",
  null
  
)

export default component.exports